import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { jsx as _jsx } from "react/jsx-runtime";
const BetaBadge = () => /*#__PURE__*/_jsx(Badge, {
  use: "beta",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "personalizationLib.shared.badges.beta"
  })
});
export default BetaBadge;